import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { formatApiError } from "@/lib/auth";
import { UserPlus } from "lucide-react";
import { fmtDate } from "@/lib/constants";

export default function BusinessTeam() {
  const [org, setOrg] = useState(null);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const load = () => api.get("/org/me").then(r => setOrg(r.data));
  useEffect(() => { load(); }, []);

  const invite = async () => {
    try {
      await api.post("/org/invite", form);
      toast.success("Member invited");
      setOpen(false);
      setForm({ name: "", email: "", password: "" });
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  if (!org) return <div className="text-muted-foreground">Loading…</div>;

  return (
    <div className="space-y-6" data-testid="business-team">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.16em] text-muted-foreground">Organization</div>
          <h1 className="font-display text-3xl font-bold text-court">{org.name}</h1>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button className="rounded-sm bg-primary" data-testid="invite-trigger"><UserPlus className="h-4 w-4 mr-2" />Invite member</Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Add a team member</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Name</Label><Input value={form.name} onChange={(e) => set("name", e.target.value)} data-testid="invite-name" /></div>
              <div><Label>Email</Label><Input type="email" value={form.email} onChange={(e) => set("email", e.target.value)} data-testid="invite-email" /></div>
              <div><Label>Temporary password</Label><Input type="password" value={form.password} onChange={(e) => set("password", e.target.value)} data-testid="invite-password" /></div>
            </div>
            <DialogFooter><Button onClick={invite} className="rounded-sm bg-primary" data-testid="invite-confirm">Invite</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <div className="bg-card rounded-sm border border-stone/60  overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs uppercase tracking-[0.16em] text-muted-foreground">
            <th className="p-3">Name</th><th className="p-3">Email</th><th className="p-3">Joined</th>
          </tr></thead>
          <tbody className="divide-y divide-border">
            {(org.member_details || []).map(m => (
              <tr key={m.id} data-testid={`team-row-${m.email}`}>
                <td className="p-3 font-medium">{m.name}</td>
                <td className="p-3">{m.email}</td>
                <td className="p-3 text-muted-foreground">{fmtDate(m.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
